module.exports = __webpack_public_path__ + "img/928a6e0.jpg";